import { Check } from "@mui/icons-material";

const StepCircle = (props) => {
  const { active, completed, className } = props;

  return (
    <div
      className={className}
      style={{
        color: completed ? "#4caf50" : active ? "#152d51" : "#bbb",
      }}
    >
      {completed ? <Check /> : <div style={{ width: 10, height: 10, borderRadius: "50%", background: active ? "#152d51" : "#bbb" }} />}
    </div>
  );
};

export default StepCircle;
